import React, { useEffect, useState } from 'react';
import '../assets/css/main.css';
import AOS from "aos";
import "aos/dist/aos.css";
import blog1 from "../assets/img/updates/neet 2024.jpg";
import blog2 from "../assets/img/updates/medical college.webp";
import blog3 from "../assets/img/updates/neet preparation.jpg";

const BlogCards = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    const [visibleDropdown, setVisibleDropdown] = useState(null);

    const posts = [
        {
            imgSrc: blog1,
            date: 'December 12',
            title: 'NEET 2024: Everything You Need to Know About the Latest Updates and Seat Availability',
            author: 'Krishna Kumar',
            category: 'Ceo & Founder',
            link: 'blog-details.html',
            additionalLinks: [
                { name: "NEET Official Website", link: "https://neet.nta.nic.in/" },
                { name: "Medical Seat Availability", link: "https://www.mcc.nic.in/" },
                { name: "Exam Preparation Tips", link: "https://www.aakash.ac.in/neet-preparation-tips" },
            ],
        },
        {
            imgSrc: blog2,
            date: 'July 17',
            title: 'Top Colleges in India for Medical Aspirants: Rankings and Admission Process',
            author: 'Krishna Kumar',
            category: 'Ceo & Founder',
            link: 'blog-details.html',
            additionalLinks: [
                { name: "Top Medical Colleges", link: "https://www.nirfindia.org/2023/MedicalRanking.html" },
                { name: "Admission Process", link: "https://www.mciindia.org/CMS/" },
                { name: "Ranking Information", link: "https://www.collegedunia.com/medical" },
            ],
        },
        {
            imgSrc: blog3,
            date: 'September 05',
            title: 'How to Prepare for NEET 2024: Tips, Strategies, and Resources',
            author: 'Krishna Kumar',
            category: 'Ceo & Founder',
            link: 'blog-details.html',
            additionalLinks: [
                { name: "Study Resources", link: "https://www.unacademy.com/" },
                { name: "Mock Tests", link: "https://testseries.aakash.ac.in/" },
                { name: "NEET Guidelines", link: "https://byjus.com/neet/" },
            ],
        },
    ];

    const toggleDropdown = (index) => {
        setVisibleDropdown((prev) => (prev === index ? null : index));
    };

    return (
        <section id="recent-posts" className="recent-posts section">
            <div className="container section-title" data-aos="fade-up">
                <h2>Recent Updates</h2>
                <p>Explore the recent updates from MyCareerGems</p>
            </div>

            <div className="container">
                <div className="row gy-5">
                    {posts.map((post, index) => (
                        <div
                            className="col-xl-4 col-md-6"
                            key={index}
                            data-aos="fade-up"
                            data-aos-delay={(index + 1) * 100}
                        >
                            <div className="post-item position-relative h-100">
                                <div className="post-img position-relative overflow-hidden">
                                    <img src={post.imgSrc} className="img-fluid card-img" alt="" />
                                    <span className="post-date">{post.date}</span>
                                </div>

                                <div className="post-content d-flex flex-column">
                                    <h3 className="post-title">{post.title}</h3>

                                    <div className="meta d-flex align-items-center">
                                        <div className="d-flex align-items-center">
                                            <i className="bi bi-person"></i> <span className="ps-2">{post.author}</span>
                                        </div>
                                        <span className="px-3 text-black-50">/</span>
                                        <div className="d-flex align-items-center">
                                            <span className="ps-2">{post.category}</span>
                                        </div>
                                    </div>

                                    <hr />

                                    <div className="readmore">
                                        <button
                                            onClick={() => toggleDropdown(index)}
                                            className="btn btn-link p-0 d-flex align-items-center"
                                            style={{
                                                textDecoration: 'none',
                                                color: '#007bff',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <span>Read More</span>
                                            <i className="bi bi-arrow-right ms-2"></i>
                                        </button>
                                    </div>
                                </div>
                                
                                {visibleDropdown === index && (
                                    <div
                                        className="dropdown-links m-3"
                                        style={{
                                            border: '2px solid #ddd',
                                            borderRadius: '8px',
                                            backgroundColor: '#f8f9fa',
                                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                            padding: '10px',
                                            animation: 'fadeIn 0.3s ease',
                                        }}
                                    >
                                        <ul style={{ listStyle: 'none', paddingLeft: '0', margin: '0' }}>
                                            {post.additionalLinks.map((link, linkIndex) => (
                                                <li key={linkIndex} className="my-2">
                                                    <a
                                                        href={link.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            textDecoration: 'none',
                                                            color: '#007bff',
                                                            fontWeight: '500',
                                                        }}
                                                    >
                                                        • {link.name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default BlogCards;
